<template>
  <div class='landing' style="position:relative;">
     <div class="hero">
        <div class="navbar1">
            <div class="logo">
                <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 437.26 67.97"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M67.33,14.69l-14,38.74H42.48l-8.71-24-9,24.05H14L0,14.69H10.58L19.73,40.9l9.5-26.21h9.51L48,40.9l9.43-26.21Z"/><path d="M109.23,37.23H79.92C81,42.05,85.11,45,91,45a13.13,13.13,0,0,0,9.72-3.74l6,6.48c-3.6,4.1-9,6.26-16,6.26-13.39,0-22.1-8.42-22.1-19.94s8.85-20,20.66-20c11.38,0,20.16,7.64,20.16,20.09C109.44,35.07,109.3,36.29,109.23,37.23ZM79.78,30.67H98.86a9.68,9.68,0,0,0-19.08,0Z"/><path d="M159.12,34.06c0,12.17-8.42,19.94-19.29,19.94-5.19,0-9.36-1.65-12.17-5v4.47H116.93V0h11.23V18.79c2.88-3.16,6.84-4.68,11.67-4.68C150.7,14.11,159.12,21.89,159.12,34.06Zm-11.37,0c0-6.7-4.25-10.73-9.87-10.73s-9.86,4-9.86,10.73,4.25,10.73,9.86,10.73S147.75,40.76,147.75,34.06Z"/><path d="M200.23,31.32V53.43H189.72V48.6c-2.09,3.53-6.12,5.4-11.81,5.4-9.07,0-14.47-5-14.47-11.73,0-6.84,4.82-11.6,16.63-11.6H189c0-4.82-2.88-7.63-8.93-7.63a18.65,18.65,0,0,0-11.16,3.6l-4-7.85c4.25-3,10.51-4.68,16.71-4.68C193.4,14.11,200.23,19.59,200.23,31.32ZM189,41.19v-4h-7.7c-5.26,0-6.91,1.94-6.91,4.53,0,2.81,2.37,4.68,6.33,4.68C184.47,46.44,187.71,44.72,189,41.19Z"/><path d="M250.78,14.69V47c0,14.4-7.78,21-21.75,21-7.34,0-14.47-1.8-19-5.32l4.47-8.07C217.8,57.25,223.2,59,228.17,59c7.92,0,11.38-3.6,11.38-10.58V46.73c-3,3.24-7.21,4.83-12.25,4.83-10.72,0-19.37-7.42-19.37-18.73s8.65-18.72,19.37-18.72c5.4,0,9.87,1.8,12.82,5.55v-5ZM239.69,32.83c0-5.68-4.25-9.5-10.15-9.5s-10.23,3.82-10.23,9.5,4.32,9.51,10.23,9.51S239.69,38.52,239.69,32.83Z"/><path d="M299,37.23H269.64c1.08,4.82,5.18,7.77,11.09,7.77a13.13,13.13,0,0,0,9.72-3.74l6,6.48c-3.6,4.1-9,6.26-16,6.26-13.39,0-22.11-8.42-22.11-19.94s8.86-20,20.67-20c11.38,0,20.16,7.64,20.16,20.09C299.16,35.07,299,36.29,299,37.23ZM269.5,30.67h19.08a9.68,9.68,0,0,0-19.08,0Z"/><path d="M346.25,31.25V53.43H335V33c0-6.27-2.88-9.15-7.85-9.15-5.4,0-9.29,3.32-9.29,10.44V53.43H306.65V14.69h10.73v4.54c3-3.32,7.56-5.12,12.81-5.12C339.34,14.11,346.25,19.44,346.25,31.25Z"/><path d="M354,34.06c0-11.67,9-20,21.6-20,8.14,0,14.55,3.53,17.36,9.87l-8.72,4.68a9.66,9.66,0,0,0-8.71-5.33c-5.69,0-10.15,4-10.15,10.73s4.46,10.73,10.15,10.73a9.54,9.54,0,0,0,8.71-5.33l8.72,4.75C390.1,50.4,383.69,54,375.55,54,363,54,354,45.72,354,34.06Z"/><path d="M437.26,14.69,419.76,55.8C416,65.17,410.69,68,403.7,68c-4,0-8.28-1.29-10.8-3.52l4.11-8a9.89,9.89,0,0,0,6.33,2.45c3.1,0,4.83-1.37,6.34-4.82l.14-.36-16.77-39h11.59L415.51,41l10.95-26.28Z"/></g></g></svg> -->
            </div>
            <v-btn style="color:white;" rounded outlined href='/contact' >Contact Us</v-btn>
        </div>
        <div class="contentx">
            <div class="word1">Welcome to</div>
            <h1 >RakangTham</h1>
            <v-btn color="white" rounded href='/home'>Enter to website</v-btn>
            
        </div>
       <div id="leaves">
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i>
  <i></i> 
</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Landing'
}
//  import x from "../../../client/public/image/lotus.jpg"
</script>

<style >
.word1{
    font-size: 30px;
    color: #ffffff;
}
.word2{
    margin: 0px 0px 40px;
}
.hero{
    width:100%;
    height: 100vh;
    
    background-image: url("http://3.bp.blogspot.com/-bVDEdYtZ35s/UGj5-Dob7iI/AAAAAAAAAMw/AnFCZ6znEao/s1600/222.jpg") ;
    background-size: cover;
    position: relative;
    overflow: hidden;
}
.logo{
    width: 100px;
    cursor: pointer;
}
.navbar1{
 
    width: 85%;
    height: 15%;
    /* margin: auto; */
    display: flex;
    align-items: center;
    justify-content:space-between;
}
/* v-btn{
    color: #fbfcfb;
    padding: 10px 25px;
    background: transparent;
    border-radius:20px ;
    outline: none;
    cursor: pointer;
} */
.contentx{
    color:#fbfcfb;
    position:absolute;
    top:70%;
    right:10%;
    transform: translateY(-50%);
    z-index: 2;
    
}
.contentx h1{
          color: #E38955 !important;
          font-size: 80px;
}

@media only screen and (max-width: 321px) {
    .contentx{
    top:85%;
    left:8%;
    transform: translateY(-50%);
    z-index: 2;
    
}
    .contentx h1{
          font-size: 48px;
}

    
}
@media only screen and (max-width: 376px) {
    .contentx{
    top:90%;
    left:8%;
    transform: translateY(-50%);
    z-index: 2;
    
}
    .contentx h1{
          font-size: 48px;
    }
    .word1{
        font-size: 30px;
    }
}
@media only screen and (max-width: 415px) {
    .contentx{
    top:90%;
    left:8%;
    transform: translateY(-50%);
    z-index: 2;
    
}
    .contentx h1{
          font-size: 38px;
    }
    .word1{
        font-size: 30px;
    }
} 
@media only screen and (max-width: 540px) {
    .contentx{
    top:80%;
    left:8%;
    transform: translateY(-50%);
    z-index: 2;
    
}
    .word1{
      font-size: 10px;
    }
    .word2{
      font-size: 20px;
    }
} 
@media only screen and (max-width: 769px) {
    .contentx{
    color:#fbfcfb;
    position:absolute;
    top:85%;
    left:8%;
    transform: translateY(-50%);
    z-index: 2;
}
}
@media only screen and (max-width: 1024px) { 
    .contentx{
    color:#fbfcfb;
    position:absolute;
    top:85%;
    left:8%;
    transform: translateY(-50%);
    z-index: 2;
}
    .word1{
      font-size: 30px;
    }
    .word2{
      font-size: 40px;
    }
}
h1{
    font-size:80px;
    margin: 10 px 0 30px;
    line-height: 80px;

}

/* leaf animations */

#leaves {position:relative;top:-100%;width:100%;text-align: right;}

#leaves i {
    display: inline-block;
    width: 200px;
    height: 150px;
    background: linear-gradient(to bottom right, #309900, #005600);
    transform: skew(20deg);
    border-radius: 5% 40% 70%;
    box-shadow: inset 0px 0px 1px #222;
    border: 1px solid #333;
    z-index: 1;
    -webkit-animation: falling 5s 0s infinite;
}

#leaves i:nth-of-type(2n) { -webkit-animation: falling2 5s 0s infinite; }
#leaves i:nth-of-type(3n) { -webkit-animation: falling3 5s 0s infinite; }

#leaves i:before {
  position: absolute;
  content: '';
  top: 117px;
  right: 9px;
  height: 27px;
  width: 32px;
  transform: rotate(49deg);
  border-radius: 0% 15% 15% 0%;
  border-top: 1px solid #222;
  border-bottom: 1px solid #222;
  border-left: 0px solid #222;
  border-right: 1px solid #222;
  background: linear-gradient(to right, rgba(0,100,0,1), #005600);
  z-index: 1;
}

#leaves i:after {
  content: '';
  height: 125px;
  width: 10px;
  background: linear-gradient(to right, rgba(0,0,0,.15), rgba(0,0,0,0));
  display: block;
  transform: rotate(125deg);
  position: absolute;
  left: 85px;
  border-radius:50%;
}


#leaves i:nth-of-type(n)    { height:23px; width:30px; }
#leaves i:nth-of-type(n):before { width:7px; height:5px; top:17px; right:1px; }
#leaves i:nth-of-type(n):after { width:2px; height:17px; left: 12px; top:0px; }

#leaves i:nth-of-type(2n+1)    { height:11px; width:16px; }
#leaves i:nth-of-type(2n+1):before { width:4px; height:3px; top:7px; right:0px; }
#leaves i:nth-of-type(2n+1):after { width:2px; height:6px; left: 5px; top:1px; }

#leaves i:nth-of-type(3n+2)  { height:17px; width:23px; }
#leaves i:nth-of-type(3n+2):before  { height:4px; width:4px; top:12px; right:1px; }
#leaves i:nth-of-type(3n+2):after  { height:10px; width:2px; top:1px; left:8px; }

#leaves i:nth-of-type(n)   { -webkit-animation-delay: 1.9s;}
#leaves i:nth-of-type(2n)  { -webkit-animation-delay: 3.9s;}
#leaves i:nth-of-type(3n)  { -webkit-animation-delay: 2.3s;}
#leaves i:nth-of-type(4n)  { -webkit-animation-delay: 4.4s;}
#leaves i:nth-of-type(5n)  { -webkit-animation-delay: 5s;  }
#leaves i:nth-of-type(6n)  { -webkit-animation-delay: 3.5s;}
#leaves i:nth-of-type(7n)  { -webkit-animation-delay: 2.8s;}
#leaves i:nth-of-type(8n)  { -webkit-animation-delay: 1.5s;}
#leaves i:nth-of-type(9n)  { -webkit-animation-delay: 3.3s;}
#leaves i:nth-of-type(10n) { -webkit-animation-delay: 2.5s;}
#leaves i:nth-of-type(11n) { -webkit-animation-delay: 1.2s;}
#leaves i:nth-of-type(12n) { -webkit-animation-delay: 4.1s;}
#leaves i:nth-of-type(13n) { -webkit-animation-delay: 1s;  }
#leaves i:nth-of-type(14n) { -webkit-animation-delay: 4.7s;}
#leaves i:nth-of-type(15n) { -webkit-animation-delay: 3s;  }

#leaves i:nth-of-type(n)    { background: linear-gradient(to bottom right, #309900, #005600); }
#leaves i:nth-of-type(2n+2)  { background: linear-gradient(to bottom right, #5e9900, #2b5600); }
#leaves i:nth-of-type(4n+1)  { background: linear-gradient(to bottom right, #990, #564500); }

#leaves i:nth-of-type(n)    { opacity: .7;}
#leaves i:nth-of-type(3n+1)  { opacity: .5;}
#leaves i:nth-of-type(3n+2)  { opacity: .3;}

#leaves i:nth-of-type(n)    {transform: rotate(180deg);}


#leaves i:nth-of-type(n) { -webkit-animation-timing-function:ease-in-out;}

@-webkit-keyframes falling {
    
    0% {
        -webkit-transform:
            translate3d(300,0,0)
            rotate(0deg);
    }
    
    100% {
        -webkit-transform:
            translate3d(-350px,700px,0)
            rotate(90deg);
        opacity: 0;
    }
}

@-webkit-keyframes falling3 {
     0% {
        -webkit-transform:
            translate3d(0,0,0)
            rotate(-20deg);
    }
    
    100% {
        -webkit-transform:
            translate3d(-230px,640px,0)
            rotate(-70deg);
        opacity: 0;
    }
}

@-webkit-keyframes falling2 {
     0% {
        -webkit-transform:
            translate3d(0,0,0)
            rotate(90deg);
    }
    
    100% {
        -webkit-transform:
            translate3d(-400px,680px,0)
            rotate(0deg);
        opacity: 0;
    }
}
</style>